import React from 'react';
import DemoFrame from './DemoFrame';
import useDemoPlayer, { typingDuration, useTypedText } from './useDemoPlayer';
import { DEMO_SAENGGIBU } from './demoFixtures';
import { calculateNEISBytes } from '../../utils/neisBytes';

const D = DEMO_SAENGGIBU;
const OUTPUT_BYTES = calculateNEISBytes(D.output);

// 0 메모 입력 → 1 버튼 누름 → 2 작성 중 → 3 결과 타이핑 → 4(완성) 결과 카드
const STEPS = [
  typingDuration(D.memo, 1, 40),
  550,
  1100,
  typingDuration(D.output, 3, 16),
];

const SaenggibuResultDemo = ({ surface = 'home', title = '생기부 작성', autoStart = false }) => {
  const player = useDemoPlayer({ steps: STEPS, surface, feature: 'saenggibu', autoStart });
  const { phase, done, paused } = player;
  const memo = useTypedText(D.memo, { active: phase === 0, complete: phase > 0, paused, charsPerTick: 1, tickMs: 40 });
  const output = useTypedText(D.output, { active: phase === 3, complete: phase > 3, paused, charsPerTick: 3, tickMs: 16 });
  const showCard = phase >= 2;
  const cardDone = done;

  return (
    <DemoFrame title={title} player={player}>
      <div className="wqdemo-sg-setup">
        <div className="wqdemo-chip-row">
          <span className="wqdemo-chip is-active">{D.category}</span>
          <span className="wqdemo-chip is-active">{D.subject}</span>
        </div>
        <div>
          <span className="wqdemo-label">{D.student} 학생 활동 메모</span>
          <div className="wqdemo-input">
            {memo}
            {phase === 0 && <span className="wqdemo-cursor" />}
          </div>
        </div>
        {!showCard && (
          <div className="wqdemo-row-end">
            <span className={`wqdemo-btn is-primary${phase === 1 ? ' is-pressed' : ''}`}>생기부 만들기</span>
          </div>
        )}
      </div>

      {showCard && (
        <div className="wqdemo-sg-card wqdemo-in">
          <div className="wqdemo-sg-card-head">
            <span className={`wqdemo-bytes${cardDone ? ' is-ok' : ''}`}>
              {cardDone ? `${OUTPUT_BYTES}B · 목표 ${D.byteLimit}B에 맞췄어요` : '작성 중…'}
            </span>
            {cardDone && (
              <span className="wqdemo-sg-card-actions">
                <span className="wqdemo-btn is-outline">AI로 다듬기</span>
                <span className="wqdemo-btn is-primary">복사</span>
                <span className="wqdemo-btn is-outline" aria-label="더 보기">⋯</span>
              </span>
            )}
          </div>
          <div className="wqdemo-sg-card-body">
            {phase === 2 ? (
              <>
                <div className="wqdemo-skeleton" style={{ width: '92%' }} />
                <div className="wqdemo-skeleton" style={{ width: '84%' }} />
                <div className="wqdemo-skeleton" style={{ width: '60%' }} />
              </>
            ) : (
              <>
                {output}
                {phase === 3 && <span className="wqdemo-cursor" />}
              </>
            )}
          </div>
        </div>
      )}
    </DemoFrame>
  );
};

export default SaenggibuResultDemo;
